<template>

    <div class="question__body" :class="{ '-locked': disabled }">
        <question-title :title="title" :sub-title="subTitle" :hashelp="hashelp" :uuid="uuid" :question-index="questionIndex"></question-title>
        <self-disablable v-if="selfDisablable" :label="selfDisablable" :answer="answer.answer"></self-disablable>

        <table class="matrix-2d">
            <thead>
                <matrix-column-group :column-group="columnGroup" :span="columns.length"></matrix-column-group>
                <tr>
                    <th class="matrix__header-title matrix-2d__header-title" v-html="headerTitle"></th>
                    <th v-for="(column, index) of columns" :key="index" :class="{ 'col-locked': isColumnDisabled(column.value) }">
                        <span v-once v-html="column.label"></span>
                    </th>
                </tr>
            </thead>
            <tbody v-if="!disabled">
                <matrix-2d-exclusive-row-sourced-row v-for="(choice, index) of rows" :key="index"
                    :question-index="questionIndex"
                    :row="choice"
                    :columns="columns"
                    :uukey="uukey"
                    :triggers="triggers"
                    :answer="answer.answer"
                    :disabled="disabled"
                    :disabled-columns="disabledColumns"
                    :read-only="readOnly"
                ></matrix-2d-exclusive-row-sourced-row>
                <matrix-other v-if="otherEnabled" :label="otherLabel" :instructions="otherInstructions" :uuid="uuid" :span="columns.length + 1" :othervalue="othervalue" :questionIndex="questionIndex"></matrix-other>
            </tbody>

        </table>
        <question-tip :questionTip="questionTip"></question-tip>
    </div>

</template>


<script>
import { isObject, map, forEach, find, differenceBy } from 'lodash';
import { questionMixin } from './mixins/question-mixin';
import { matrixMixin } from './mixins/matrix-mixin';
import { matrixColumnsMixin } from './mixins/matrix-columns-mixin';
import { matrixRowSourcedMixin } from './mixins/matrix-row-sourced-mixin';

export default {
    name: 'matrix-2d-exclusive-row-sourced',

    mixins:[
        questionMixin,
        matrixMixin,
        matrixColumnsMixin,
        matrixRowSourcedMixin,
    ],

    beforeMount()
    {
        if (isObject(this.rows))
        {
            this.$watch('rows', (newVals, oldVals) =>
            {
                // Find which were removed:
                const removedOnes = differenceBy(oldVals, newVals, 'id');
                forEach(removedOnes, (rowItem) =>
                {
                    // Force submit answer with no value:
                    this.changeValue(null, rowItem.id);
                });
            });
        }
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/matrix-2d-exclusive-row-sourced.vue